<template>
  <div class="verification-overlay" v-if="(visible || externalVisible) && shouldShowVerification">
    <div class="verification-modal">
      <div class="modal-header">
        <h2>用户验证</h2>
      </div>
      <div class="modal-body">
        <p>您的账户需要进行验证，请完成以下验证步骤：</p>
        <div class="verification-content">
          <CustomHcaptcha
            ref="hcaptcha"
            :sitekey="siteKey"
            @verified="onCaptchaVerified"
            @expired="onCaptchaExpired"
            @error="onCaptchaError"
          />
          <div v-if="errorMessage" class="error-message">
            <n-alert type="error" :title="errorMessage" />
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <n-button type="primary" @click="submitVerification" :disabled="!isCaptchaVerified">提交验证</n-button>
      </div>
    </div>
  </div>
</template>

<script>
import verificationService from '../services/verificationService';
import CustomHcaptcha from './Hcaptcha.vue';
import { createDiscreteApi } from 'naive-ui';
import { postRequest } from '@/services/apiService';
import API from '@/services/address';

const { message } = createDiscreteApi(['message']);

export default {
  name: 'UserVerification',
  components: {
    CustomHcaptcha
  },
  data() {
    return {
      visible: false,
      isCaptchaVerified: false,
      hcaptchaToken: '',
      errorMessage: '',
    };
  },
  computed: {
    externalVisible() {
      return verificationService.getState().showVerification;
    },
    siteKey() {
      return process.env.NODE_ENV === "development"
        ? "10000000-ffff-ffff-ffff-000000000001" // 测试密钥
        : "5b98d946-f61e-4a8a-8fce-c96eda44a7cc"; // 生产环境密钥
    },
    shouldShowVerification() {
      const excludedRoutes = ['/', '/login', '/forget-password'];
      return !excludedRoutes.includes(this.$route.path);
    }
  },
  methods: {
    showOverlay() {
      this.visible = true;
    },
    closeOverlay() {
    },
    onCaptchaVerified(token) {
      this.isCaptchaVerified = true;
      this.hcaptchaToken = token;
      message.success('验证码验证成功');
    },
    onCaptchaExpired() {
      this.isCaptchaVerified = false;
      this.hcaptchaToken = '';
      message.info('验证码已过期，请重新验证');
    },
    onCaptchaError(error) {
      this.isCaptchaVerified = false;
      this.hcaptchaToken = '';
      this.errorMessage = '验证码加载出错，请刷新重试';
      message.error('验证码加载出错，请刷新重试');
      console.error('hCaptcha error:', error);
    },
    submitVerification() {
      this.errorMessage = '';
      // 处理验证逻辑
      postRequest(API.VERIFY_USER, {
        email: "",
        hcaptchaToken: this.hcaptchaToken
      }).then(res => {
        console.log(res);
        if (res.success) {
          message.success('验证成功');
          verificationService.hideVerification();
          // 如果用户是在 reviewTrainPage、startTrain  ，则不能刷新页面。否则，刷新页面
          if (this.$route.path === '/reviewTrainPage' || this.$route.path === '/startTrain') {
            console.log('用户在 reviewTrainPage 或 startTrain 页面，不刷新页面');
          } else {
            console.log('用户不在 reviewTrainPage 或 startTrain 页面，刷新页面');
            window.location.reload();
          }

        } else {  
          this.errorMessage = '验证失败，请重试';
          message.error('验证失败，请重试');
        }
      }).catch(error => {
        console.log(error);
        this.errorMessage = '验证请求失败，请检查网络连接';
        message.error('验证请求失败，请检查网络连接');
      });
    }
  }
};
</script>

<style scoped>
.verification-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* 确保在最上层 */
}

.verification-modal {
  background-color: white;
  border-radius: 8px;
  width: 80%;
  max-width: 500px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.modal-header {
  margin-bottom: 20px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.modal-body {
  margin-bottom: 20px;
}

.verification-content {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.error-message {
  margin-top: 8px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style> 